import React, { useState } from "react";
import { connect } from "react-redux";
import {
  getAgentIDListInPreEnrollForm,
  setFormData,
  getPlanDetails,
  planSelectionContinue,
  yearSelection,
  setStateParams,
  getPlans,
  sendEmail,
  getZipCodes,
} from "../../../Redux/Actions/webAppActions";
import { Text } from "react-internationalization";
import history from "../../../Utils/History";
import SaveProgress from "./SaveProgress";

const EditZip = (props) => {
  const [clicked, setClicked] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);
  const [countySelect, setCountySelect] = useState(props.countyName);
  const [CountyCd, setCountyCd] = useState(props.CountyCd);
  const [value, setValue] = useState(
    props?.deeplink === true ? props?.dpzipCode : props?.zipCode
  );

  const redirect = (event) => {
    event.preventDefault();
    setClicked(true);
    if (props.ZipCodes?.length === 1) {
      setCountySelect(props.ZipCodes[0]?.countyName);
    }
  };
  const handleChange = async (event) => {
    let valueinput = event.target.value;
    valueinput = valueinput.replace(/[^0-9]+/g, "");
    setValue(valueinput);
    //setZipCode(valueinput);

    if (valueinput.length === 5) {
      await props.setStateParams("zip", valueinput);

      // this.setState({ teleScript: false });
      const zipresponse = await props.getZipCodes(valueinput);
      await props.setStateParams("planCardData", []);
      // props.setStateParams("zip", valueinput);
      if (zipresponse.status === "OK") {
        setErrorMsg(false);
        // if (props.ZipCodes && props.ZipCodes.length > 0) {
        // props.isPlansFound(true);
        // setErrorMsg(false);
        // } else {
        // props.isPlansFound(false);
        // }
        if (zipresponse?.data?.length === 1) {
          setCountySelect(zipresponse?.data[0]?.countyName);
        } else {
          setCountySelect("");
        }
      } else {
        props.setStateParams("zipCodes", {});
        await props.setStateParams("zip", "");
        let msg = zipresponse?.message
          ? zipresponse?.message
          : zipresponse?.data?.message;
        props.setSnackbar(true, msg, "error");
        await props.setStateParams("stateCd", "");
        return;
        // props.isPlansFound(true);
        // setErrorMsg(
        //   props.lang === "es"
        //     ? "Código postal incorrecto"
        //     : "Incorrect Zipcode."
        // );
      }
    } else {
      // props.isPlansFound(true);
      // setErrorMsg(
      //   props.lang === "es"
      //     ? "Ingrese el código postal adecuado."
      //     : "Please enter proper zip code."
      // );
    }
  };

  const continues = async (event) => {
    let zipcode = value;
    event.preventDefault();
    let response = [];
    if (zipcode.length === 5) {
      let call = true;
      console.log("props?.ZipCodes", props?.ZipCodes, countySelect);
      if (props.ZipCodes && props.ZipCodes.length === 1) {
        await props.setStateParams("county", props.ZipCodes[0]);
        await props.setStateParams("state", props.ZipCodes.state);
        setErrorMsg("");
      } else if (
        props.ZipCodes &&
        props.ZipCodes.length > 1 &&
        countySelect !== ""
      ) {
        await props.setStateParams("county", countySelect);

        // const params =
        props.ZipCodes.filter(
          (zipcode1) => zipcode1.countyName === props.county
        );

        await props.setStateParams("state", props.ZipCodes.state);
      } else if (
        props?.ZipCodes?.length === undefined ||
        props?.ZipCodes?.length === 0
      ) {
        call = false;
        await props.setStateParams("zip", "");
        //  props.isPlansFound(true);
        setErrorMsg(
          props.lang === "es"
            ? "Código postal incorrecto"
            : "Incorrect zip code"
        );
      } else {
        call = false;
        //  props.isPlansFound(true);
        setErrorMsg(
          props.lang === "es"
            ? "Seleccione un condado"
            : "Please Select a County"
        );
      }

      if (call === true) {
        let body = { customerId: props?.customerId };
        let params = "";
        if (props.ZipCodes.length > 1) {
          params = props.ZipCodes.filter(
            (zipcode1) => zipcode1.countyName === props.county
          );
        } else {
          params = props.ZipCodes;
        }

        response = await props.getPlans(
          zipcode,
          //this.props.county.countyCode,
          params[0]?.countyCode ? params[0]?.countyCode : CountyCd,
          body.customerId,
          //this.props.county.stateCode
          props.stateCd,
          props.year
        );
        if (response?.status != "OK") {
          let msg = response?.message
            ? response?.message
            : response?.data?.message;
          props.setSnackbar(true, msg, "error");
          return;
        }
        if (props.cardDetails.length > 0) {
          setClicked(false);
          // props.isPlansFound(false);

          // let payload = { planYear: "2023" };
          // props.yearSelection(payload);
          history.push("/e-Enroll/select-plan");
        } else {
          setClicked(false);
          //  props.isPlansFound(false);
          setErrorMsg(response.message);
        }
      }
    } else {
      setErrorMsg(
        props.lang === "es"
          ? "¡Seleccione un código postal!"
          : "Please Select a ZipCode!"
      );
    }
    //  this.props.handleHeaderWidth();
  };

  const handleChange1 = (event) => {
    let value1 = event.target ? event.target.value : event.value;
    // let name = event.target ? event.target.name : event.name;
    setCountySelect(value1);
    // this.setState((prevState) => ({
    //   ...prevState,
    //   [name]: value,
    // }));
    let stateId = props.ZipCodes.filter((f) => f.countyName === value1)[0]
      ?.stateCd;
    let countyCode = props.ZipCodes.filter((f) => f.countyName === value1)[0]
      ?.countyCode;
    props.setStateParams("CountyCd", countyCode);
    setCountyCd(countyCode);
    console.log("stateId", stateId);
    props.setStateParams("stateId", stateId);
  };

  return (
    <div className="row mb-3">
      <div className="col-6 col-md-3 col-lg-4 order-1">
        <h5 className="panel-heading bold">
          <Text id="sharp.allPlan" />
        </h5>
      </div>
      <div className="col-12 col-md-5 col-lg-6 order-3 order-md-2">
        {errorMsg && (
          <div className="error-msg error-msg-zipcode">{errorMsg}</div>
        )}
        {!clicked ? (
          <div id="zipcode_display" className="d-flex gap-2 float-right">
            <input
              autoComplete="off"
              spellcheck="false"
              aria-autocomplete="both"
              aria-haspopup="false"
              type="text"
              placeholder="Zipcode"
              className="form-control readonly border-0 w-auto"
              value={
                props.county && props.zipCode
                  ? props.countyName + " " + props.zipCode
                  : props.dpcountyName + " " + props.dpzipCode
              }
              //readonly=""
            />
            <button
              className="btn btn-shp btn-shp-sml btn-sm"
              id="btn_editzip"
              onClick={redirect}
            >
              <Text id="app.edit" />
            </button>
          </div>
        ) : (
          <div id="zipcode_edit" className="gap-2 float-right d-flex">
            <input
              autoComplete="off"
              spellcheck="false"
              aria-autocomplete="both"
              aria-haspopup="false"
              className="form-control width-90"
              type="text"
              name="permanentZip"
              id="permanentZip"
              value={value}
              minlength="5"
              maxlength="5"
              required
              onChange={handleChange}
              placeholder="Enter Zip Code"
              autofocus="autofocus"
            />
            {/* {props.ZipCodes.length > 1 && ( */}
            <select
              id="countySelect"
              name="countySelect"
              type="text"
              className="form-select w-auto"
              aria-label="Select county"
              value={countySelect}
              onChange={handleChange1}
            >
              <option value="">Select a County</option>
              {props?.ZipCodes.map((county1, index) => (
                <option value={county1.countyName} key={props.ZipCodes[index]}>
                  {county1.countyName.trim()}
                </option>
              ))}
            </select>
            {/* )} */}
            <button
              className="btn btn-shp btn-shp-sml btn-sm"
              id="btn_savezip"
              onClick={continues}
            >
              <Text id="app.ok" />
            </button>
          </div>
        )}
      </div>
      <div className="col-6 col-md-4 col-lg-2 order-2 order-md-3 text-end">
        <SaveProgress />
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  const { CountyCd, selectedPlanName, stateCd } = state.webApp;
  return {
    year: state.webApp.year?.planYear
      ? state.webApp.year.planYear
      : state.webApp.year,
    cardDetails: state.webApp.planCardData,
    zipCode: state.webApp.zip,
    guestLoggedIn: state.login.guestLogin,
    stateName: state.webApp.state,
    countyName: state.webApp.county?.countyName
      ? state.webApp.county?.countyName
      : state.webApp.county,
    email:
      state.login.emailAddress.length > 0
        ? state.login.emailAddress
        : state.login.email,
    customerId: state.login.customerId,
    planId: state.webApp.emailPlanId,
    agentLogin: state.login.agentLoggedIn,
    ZipCodes:
      JSON.stringify(state.webApp.zipCodes) === "{}"
        ? []
        : state.webApp.zipCodes,
    county: state.webApp.county,
    selectedPlanName,
    // county,
    CountyCd,
    stateCd,
    deeplink: state.login.deeplink,
    dpcountyName: state.login.dpcountyName,
    dpzipCode: state.login.dpzipCode,
    dpProductId: state.login.dpProductId,
    countyCode: state.webApp.countyCode,
    // customerId:state.login.customerId,
    theme: state.login.theme,
    prospectEnroll: state.webApp.prospectEnroll,
    selectedPlansForCompare: state.webApp.selectedPlansForCompare,
    //selectedPlanDetails: state.webApp.selectedPlanDetails,
    lang: state.webApp.language,
  };
};
const mapDispatchToProps = {
  getAgentIDListInPreEnrollForm,
  setFormData,
  getPlanDetails,
  planSelectionContinue,
  yearSelection,
  setStateParams,
  getPlans,
  sendEmail,
  getZipCodes,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditZip);
